import clsx from 'clsx';
import { CartFinanceMsg } from './CartSummary';

export default function CartPageSticky({
  checkoutButtonInView,
  checkoutButtonAboveViewport,
  subTotal,
  totalsDisplayPrice
}) {
  function handleClick() {
    document.getElementById('checkout-button').click();
  }

  return (
    <div
      className={clsx(
        'border-dawn-grey-30 sticky bottom-0 left-0 h-[158px] w-full border-t bg-white px-9 pt-3 lg:hidden',
        { hidden: checkoutButtonInView || checkoutButtonAboveViewport }
      )}
    >
      <div className="flex w-full justify-between">
        <div className="sh10">Order Total</div>
        <div className="sh10 text-[#CC4D0F]">
          ${totalsDisplayPrice(subTotal)}
        </div>
      </div>
      {subTotal >= 200 && (
        <CartFinanceMsg
          id="sticky"
          subTotal={subTotal}
          styleClass={'affirm-as-low-as body-xs pt-2'}
        />
      )}
      <button className="btn btn-primary mt-6 w-full" onClick={handleClick}>
        Checkout
      </button>
    </div>
  );
}
